import type { DesignScopeListItem } from "mock-data/design-scope";

/** Label used on timeline diamonds and bid-package badges. */
export function scopePreviewLabel(item: DesignScopeListItem): string {
  const primary =
    item.classifications.find((c) => c.system === "uni-format") ||
    item.classifications.find((c) => c.system === "master-format") ||
    item.classifications[0];
  return [primary?.number, item.title || primary?.title]
    .filter(Boolean)
    .join(" ");
}

/** Scope-item labels keyed by milestone id for one design package. */
export function groupScopePreviewsByMilestone(
  items: DesignScopeListItem[],
  designPackageId: string
): Record<string, string[]> {
  const msPreview: Record<string, string[]> = {};
  items.forEach((item) => {
    const label = scopePreviewLabel(item);
    const seenMs = new Set<string>();
    item.design_packages.forEach((c) => {
      const milestoneId = c.design_package_milestone?.id;
      if (
        c.design_package?.id === designPackageId &&
        milestoneId &&
        !seenMs.has(milestoneId)
      ) {
        seenMs.add(milestoneId);
        (msPreview[milestoneId] ??= []).push(label);
      }
    });
  });
  return msPreview;
}

/** Scope-item labels keyed by bid-package id (any design package). */
export function groupScopePreviewsByBid(
  items: DesignScopeListItem[]
): Record<string, string[]> {
  const bidPreview: Record<string, string[]> = {};
  items.forEach((item) => {
    const label = scopePreviewLabel(item);
    const seenBp = new Set<string>();
    item.bid_packages.forEach((b) => {
      if (b.id && !seenBp.has(b.id)) {
        seenBp.add(b.id);
        (bidPreview[b.id] ??= []).push(label);
      }
    });
  });
  return bidPreview;
}
